<mat-card class="question-card center">
  <mat-card-content>
    <mat-label class="mat-title question-text">{{title}}</mat-label>
    <div *ngIf="text">
      <mat-expansion-panel>
        <mat-expansion-panel-header class="right-aligned-header">
          <mat-panel-title></mat-panel-title>
          <mat-panel-description>
            {{toggleText}}
          </mat-panel-description>         
        </mat-expansion-panel-header>       
        <p>{{text}}</p>       
      </mat-expansion-panel>
    </div>
    <div class="clearfix"></div>
    <div *ngIf="ctrl">
      <mat-error *ngIf="invalid">
        <div *ngIf="ctrl.errors.required" [innerHTML]="requiredErrorMessage"></div>
      </mat-error>
    </div>
    <div [formGroup]="form">
      <div class="form-control">
        <div class="video-wrapper">
          <div class="video">
            <canvas id="canvas_{{inputData.categoryId}}" class="video"></canvas>
          </div>
          <p><span id="progress-value_{{inputData.categoryId}}"
              style="float:left;margin-left: -10px;color: #678dcc;background-color: ghostwhite;"></span></p><br />
          <progress style="width: 100%;margin-left: -10px;" id="progressbar_{{inputData.categoryId}}" name="progressbar"
            value="0" max="100" min="90"></progress>
          <div id="play_{{inputData.categoryId}}" class="play" (click)="vidplay(inputData.categoryId)"></div>
        </div>

        <video style="display: none;" oncontextmenu="return false;" id="Video1_{{inputData.categoryId}}"
          class="Video1_{{inputData.categoryId}} video">
          <source class="video" [src]="inputData.videoPath" type="video/mp4" />
          Your browser does not support HTML5 video.
        </video>
      </div>
    </div>
  </mat-card-content>
</mat-card>